import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { formatRelativeTime } from '../../utils/time';
export const SharedChatItem = /*#__PURE__*/ memo(function SharedChatItem({ chat, onClick }) {
    return /*#__PURE__*/ _jsxs("li", {
        onClick: onClick,
        className: "px-4 py-3 border-b border-border hover:bg-muted/50 cursor-pointer transition-colors",
        "data-testid": `shared-chat-${chat.chatId}`,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-start justify-between gap-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex-1 min-w-0",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "font-medium text-sm truncate",
                                children: chat.title
                            }),
                            /*#__PURE__*/ _jsxs("p", {
                                className: "text-xs text-muted-foreground",
                                children: [
                                    "Shared by ",
                                    chat.sharedBy.name
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-xs text-muted-foreground whitespace-nowrap",
                        children: formatRelativeTime(chat.sharedAt)
                    })
                ]
            }),
            chat.lastMessage && /*#__PURE__*/ _jsxs("p", {
                className: "text-xs text-muted-foreground mt-2 truncate",
                children: [
                    /*#__PURE__*/ _jsxs("span", {
                        className: "font-medium",
                        children: [
                            chat.lastMessage.role === 'assistant' ? 'AI' : 'You',
                            ":"
                        ]
                    }),
                    ' ',
                    chat.lastMessage.preview
                ]
            })
        ]
    });
});
